import { Fragment, useEffect, useState } from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import { BUS_TOPIC_GLOBALLANGUAGE, getWidgetBus } from '@/widgets/widgets';
import en from '@/locale/en.json';
import fr from '@/locale/fr.json';
import { makeValuesPredicate } from '@sgme/fp';

export const locales = {
  en,
  fr,
};
type SupportedLocale = keyof typeof locales;
const isSupportedLocale = makeValuesPredicate(Object.keys(locales) as SupportedLocale[]);
const defaultSupportedLocale = navigator.languages.find(isSupportedLocale) ?? 'en';

export const IntlProvider = ({ children }: { children: JSX.Element }) => {
  const [locale, setLocale] = useState(
    isSupportedLocale(window.xprops?.locale) ? window.xprops.locale : defaultSupportedLocale,
  );

  // Use the SGWT Widgets bus to be aware of the modification of the language,
  // which is triggered by the <sgwt-account-center> widget.
  useEffect(() => {
    const bus = getWidgetBus();
    if (bus) {
      const languageSubscription = bus.subscribe<string>(BUS_TOPIC_GLOBALLANGUAGE, (lang) => {
        if (lang && isSupportedLocale(lang.toLowerCase())) {
          setLocale(lang.toLowerCase() as SupportedLocale);
          document.querySelector('html')!.lang = lang;
        }
      });
      return () => {
        bus.unsubscribe(languageSubscription);
      };
    }
  }, []);

  return (
    <ReactIntlProvider
      locale={locale}
      defaultLocale="en"
      messages={locales[locale]}
      textComponent={Fragment}
    >
      {children}
    </ReactIntlProvider>
  );
};
